import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useLanguage } from "@/contexts/LanguageContext";

const Navigation = () => {
  const { lang, t, toggle } = useLanguage();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handle = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", handle);
    return () => window.removeEventListener("scroll", handle);
  }, []);

  const scrollToContact = (e) => {
    e.preventDefault();
    const target = document.getElementById("kapcsolat");
    if (target) target.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: [0.25, 0.1, 0.25, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-white/80 border-b border-[#1B2A4A]/5 shadow-[0_1px_0_rgba(27,42,74,0.04)]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-20">
        <a
          href="#hero"
          data-testid="nav-logo"
          className="font-serif text-xl md:text-2xl font-bold tracking-tight text-[#1B2A4A] hover:text-[#3B82F6] transition-colors duration-300"
        >
          nagysandorweb<span className="text-[#3B82F6]">.com</span>
        </a>

        <div className="flex items-center gap-3 md:gap-4">
          {/* Language Toggle */}
          <button
            data-testid="lang-toggle"
            onClick={toggle}
            aria-label={lang === "hu" ? "Switch to English" : "Magyarra váltás"}
            className="group relative inline-flex items-center rounded-full border border-[#1B2A4A]/15 bg-white/60 backdrop-blur-sm h-10 md:h-11 p-1 text-sm font-medium text-[#1B2A4A] transition-all duration-300 hover:border-[#1B2A4A]/30"
          >
            <span
              className={`absolute top-1 bottom-1 w-[42%] rounded-full bg-[#1B2A4A] transition-all duration-300 ease-out ${
                lang === "hu" ? "left-1" : "left-[57%]"
              }`}
              aria-hidden="true"
            />
            <span
              data-testid="lang-option-hu"
              className={`relative z-10 px-3 md:px-4 tracking-wide transition-colors duration-300 ${
                lang === "hu" ? "text-white" : "text-[#1B2A4A]/70"
              }`}
            >
              HU
            </span>
            <span
              data-testid="lang-option-en"
              className={`relative z-10 px-3 md:px-4 tracking-wide transition-colors duration-300 ${
                lang === "en" ? "text-white" : "text-[#1B2A4A]/70"
              }`}
            >
              EN
            </span>
          </button>

          <button
            data-testid="nav-contact-button"
            onClick={scrollToContact}
            className="group relative inline-flex items-center gap-2 rounded-full bg-[#1B2A4A] px-5 md:px-7 py-2.5 md:py-3 text-sm md:text-base font-medium text-white transition-all duration-300 hover:bg-[#2A4070] active:scale-95 shadow-[0_8px_24px_-12px_rgba(27,42,74,0.4)]"
          >
            <span className="hidden sm:inline">{t.nav.contact}</span>
            <span className="sm:hidden">
              {lang === "hu" ? "Kapcsolat" : "Contact"}
            </span>
            <span className="inline-block transition-transform duration-300 group-hover:translate-x-1">
              →
            </span>
          </button>
        </div>
      </div>
    </motion.header>
  );
};

export default Navigation;
